import { Injectable } from '@angular/core';
import { BenchmarkOccupation } from '../../core-data-model/BenchmarkOccupation.model';
import { BenchmarkOccupationServerEntry } from '../../core-data-model/BenchmarkOccupationApi.serverinterface';

@Injectable({
    providedIn: 'root'
})
export class BenchmarkOccupationTransformers {
    transformFromServer(
        json: BenchmarkOccupationServerEntry,
        title: string
    ): BenchmarkOccupation {
        return new BenchmarkOccupation({
            occupation: title,
            id: json.onetSocCode,
            jobFamily: json.jobTitle,
            onetJobDescription: json.onetJobDescription,
            alternateJobTitles: json.alternateJobTitles
        });
    }
}
